export default "__VITE_ASSET__BZIMpez8__"